import styled from 'styled-components';
import {
  subMenuDropdownBackground,
  primaryColorLight,
  primaryColorWeak,
} from '../../config/colors';

export const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: ${subMenuDropdownBackground};
  padding: 20px 30px;

  @media print {
    background-color: inherit;
    padding: 20px 0;
  }
`;

export const TableTitle = styled.p`
  width: 100%;
  margin-bottom: 35px;
`;

export const TableWrapper = styled.div`
  width: 100%;
  table {
    width: 100%;
    text-align: center;
    border-spacing: 0;
    border-collapse: collapse;
    background-color: white;
    word-break: break-word;
    table-layout: fixed;

    colgroup {
      col:nth-child(1) {
        width: 20%;
      }
      col:nth-child(2) {
        width: 40%;
      }
      col:nth-child(3) {
        width: 35%;
      }
      col:nth-child(4) {
        width: 5%;
      }
    }
  }
  td,
  th {
    padding: ${(props) => (props.printMode ? 2 : 5)}px;
    border: 2px solid ${primaryColorLight};
    font-size: ${(props) => (props.printMode ? 0.625 : 0.781)}rem;
  }
  th {
    background-color: ${primaryColorWeak};
    font-size: ${(props) => (props.printMode ? 0.75 : 0.875)}rem;
  }
  thead > tr:nth-child(2) {
    th:nth-child(4),
    th:nth-child(5),
    th:nth-child(6),
    th:nth-child(7),
    th:nth-child(8),
    th:nth-child(9),
    th:nth-child(11),
    th:nth-child(12),
    th:nth-child(13) {
      background-color: whiteSmoke;
      font-size: ${(props) => (props.printMode ? 0.625 : 0.781)}rem;
      font-weight: 800;
    }
  }
  thead > tr:nth-child(3) {
    th:nth-child(5),
    th:nth-child(6),
    th:nth-child(7),
    th:nth-child(8),
    th:nth-child(9),
    th:nth-child(11),
    th:nth-child(12),
    th:nth-child(13) {
      background-color: whiteSmoke;
      font-size: ${(props) => (props.printMode ? 0.625 : 0.781)}rem;
      font-weight: 800;
    }
  }
  tr {
    td:first-child {
      width: 20%;
    }
    td:nth-child(2) {
      width: 40%;
    }
  }

  @media print {
    table {
      th, td {
         padding: 2px;
         overflow: hidden;
      }
    }
  }
`;
